export const setApiError = payload => ({
  type: 'SET_API_ERROR',
  payload, // { status: 404 | 403, message: '...' }
});

export const clearApiError = () => ({
  type: 'CLEAR_API_ERROR',
});
